<template>
  <SplitViewTemplate
    :screenConfig="setScreenConfig"
    :backButtonRoute="'/home'"
    :dataModel="formModel"
    :formConfig="setFormConfig"
    :persistenceKey="'gl-account-list'"
    :customMessages="customMessages"
  />
</template>

<script>
import SplitViewTemplate from "../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      formModel: {
        Inactive: true,
        IsPostalData: false,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
        GLGroup2Code: "",
        DateFirstUsed: null,
      },
    };
  },
  computed: {
    customMessages() {
      return {
        success: {
          message: `Account <Code> - <Description> has been successfully created`,
          keys: ["Code", "Description"],
        },
      };
    },
    setScreenConfig() {
      var config = {
        title: "GL Accounts",
        ScreenName: "GL Accounts",
        pageRoute: "/gl-accounts",
        saveEndPoint: "Save_GLChart",
        // updateEndPoint: "GLChart",
        recordEndPoint: "GLChart",

        exportFileName: "GLAccounts",

        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "GLChart",

              filter: "",
              serverPaging: true,
              allowGrouping: false,
              expand: ["GLGroup1", "GLGroup2", "GLGroup3"],
              postProcessCallback: this.glAccountPostProcess,
            },

            rowSelect: {
              view: this,
              page: "gl-accounts",
              mode: "review",
              idProperty: "Code",
              idMode: "Guid",
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: true,
            openFilter: true,
            openFilterByDefault: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/gl-accounts/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "Account",
              sortOrder: "asc",
              sortIndex: 0,
              // dataField: "Code",
              gridDataField: "ComputedStringCode",
              allowHiding: false,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "ComputedStringCode",
                  label: "Account Code",
                  allowSearch: false,
                },
                {
                  dataField: "Description",
                  label: "Account Description",
                },
              ],
              filterIndex: 0,
              filterDataField: "GLAccountSearchText",
              dataType: "string",
              type: "Text",
            },
            {
              screenField: "AccountType",
              dataField: "AccountType",
              // cellTemplate: undefined,
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "AccountTypeDescription",
                  },
                ],
                secondary: [
                  {
                    dataField: undefined,
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "AccountType",
                  allowSearch: false,
                  label: "Account Type Code",
                },
                {
                  dataField: "AccountTypeDescription",
                  label: "Account Type Description",
                  allowSearch: false,
                },
              ],
              filterIndex: 1,
              editorTemplate: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
              },
              valueExpr: "Description",
              displayExpr: "Description",
            },
            {
              screenField: "BasCode",
              filterIndex: 2,
              // visible: false,
            },
            {
              screenField: "GLGroup1Code",
              exportFields: [
                {
                  dataField: "GLGroup1.Description",
                  label: "GLGroup 1 Description",
                },
                {
                  dataField: "GLGroup1Code",
                  label: "GLGroup 1 Code",
                  allowSearch: false,
                },
              ],
              filterIndex: 3,
            },
            {
              screenField: "GLGroup2Code",
              exportFields: [
                {
                  dataField: "GLGroup2.Description",
                  label: "GLGroup 2 Description",
                },
                {
                  dataField: "GLGroup2Code",
                  label: "GLGroup 2 Code",
                  allowSearch: false,
                },
              ],
              filterIndex: 4,
            },
            {
              screenField: "GLGroup3Code",
              type: "number",
              alignment: "left",
              exportFields: [
                {
                  dataField: "GLGroup3.Description",
                  label: "GLGroup 3 Description",
                },
                {
                  dataField: "GLGroup3Code",
                  label: "GLGroup 3 Code",
                  allowSearch: false,
                },
              ],

              filterIndex: 5,
            },

            {
              screenField: "Status",
              // filterDataField: "FriendlyInactive",
              filterIndex: 6,
            },
          ],
        },
      };

      return config;
    },

    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          audit: true,
          save: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: this.setActiveReadOnly,
              },
            },
          ],
          toolbarFormLocation: "after",
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                screenField: "Code",
                dataField: "Code",

                label: {
                  text: "Account",
                },

                validationRules: [
                  {
                    type: "numeric",
                    message: "Account must be a number",
                  },

                  {
                    type: "required",
                    message: "Account is required",
                  },
                ],
                editorOptions: {
                  valueChangeEvent: "keyup",
                  maxLength: 5,
                  value: undefined,
                },
                allowUpdate: this.baseView.mode != "create" ? false : true,
              },

              {
                dataField: "Description",
                label: "Description",
                // required: true,
                visible: true,
                cellTemplate: undefined,
                editorOptions: {
                  maxLength: 35,
                },
                validationRules: [
                  {
                    type: "custom",
                    validationCallback: (e) => {
                      e.rule.message = `Description only allow maximum length of 35 characters`;
                      return e.value.length < 36;
                    },
                  },
                  {
                    type: "required",
                    message: "Description is required",
                  },
                ],
              },
              {
                screenField: "AccountType",
                dataField: "AccountType",
                required: "true",
                // cellTemplate:undefined,
                editorOptions: {
                  readOnly: this.formModel.DateFirstUsed != null,
                },
              },

              {
                screenField: "BasCode",
                required: "true",
                // visible: false,
              },
              {
                screenField: "GLGroup1Code",
                label: {
                  text: "Group 1",
                },
                required: "true",
              },
              {
                screenField: "GLGroup2Code",
                label: {
                  text: "Group 2",
                },
                required: "true",
              },

              {
                screenField: "GLGroup3Code",
                label: {
                  text: "Group 3",
                },
                required: "true",
                searchExpr: ["Description", "CodeComputedString"]
              },
            ],
          },
        ],
      };

      return form;
    },
    // setDefaultEdit() {
    //   return this.formModel["IsDefaultData"] || !this.formModel["Inactive"];
    //   //return  null
    // },
    setActiveReadOnly() {
      // return this.formModel["SetDefault"] ? true : false;
      return null;
    },
    // setAsPostal() {
    //   return this.formModel["SetAsPostalAddress"] == true ? false : true;
    // },
  },
  methods: {
    glAccountPostProcess(data) {
      data.forEach((element) => {
        // GLGroup1Description
        element.GLGroup1Description = element.GLGroup1.Description;
        // element.GLGroup1Code = 1;
        element.GLGroup2Description = element.GLGroup2.Description;
        element.GLGroup3Description = element.GLGroup3.Description;

        element.AccountTypeCode = element.AccountType;

        if (element.AccountTypeCode == "I") {
          element.AccountTypeDescription = "Income";
        } else if (element.AccountTypeCode == "E") {
          element.AccountTypeDescription = "Expense";
        } else if (element.AccountTypeCode == "A") {
          element.AccountTypeDescription = "Asset";
        } else if (element.AccountTypeCode == "L") {
          element.AccountTypeDescription = "Liability ";
        }
      });

      return data;
    },
  },
};
</script>
